import React from 'react';
import { StatefulButtonGroup, StatefulButtonGroupProps } from 'baseui/button-group';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { useStyletron } from '../../Themes';
import { firstButtonStyles, buttonBaseStyles } from './styles';
import { mergeOverrides } from 'baseui';
import * as meta from '../../meta-data.json';
import { ToolbarButton } from './view';

export const StatefulView = (props: IDummyProps &
	Omit<Omit<StatefulButtonGroupProps, 'kind'>, 'children'>) => {
	const { children, overrides, disableKeyboardSupport, initialState, ...rest } = props;
	const [css] = useStyletron();
	let shape;
	let buttonClassName;

	return (
		<StatefulButtonGroup
			{...rest}
			initialState={initialState}
			overrides={overrides ? mergeOverrides(customOverrides(props) as any, overrides as any) : customOverrides(props) as any}
		>
			{React.Children.map(children, (item, index) => {
				shape = item.props.shape || props.shape || 'square';
				buttonClassName = buttonBaseStyles(props.theme);

				if (!props.shape || props.shape === 'default') {
					if (index === 0) {
						shape = item.props.shape || props.shape || 'first';
						buttonClassName = firstButtonStyles(props.theme);
					}
					if (index === React.Children.toArray(props.children).length - 1) {
						shape = item.props.shape || props.shape || 'last';
					}
				}

				return (
					<ToolbarButton
						item={item}
						key={index}
						dataKey={index}
						childrenProps={children.props}
						theme={props.theme}
						size={props.size}
						tabIndex="0" // TODO - ask Joao
						buttongroupShape={shape}
						className={`${item?.props?.className} ${css({ ...buttonClassName })}`}
						disableKeyboardSupport={disableKeyboardSupport}
					/>
				);
			})}
		</StatefulButtonGroup>
	);
};
